import { Container, Icon, Text } from "@fluidattacks/design";
import _ from "lodash";

import type { IDependencyTypeConfig } from "features/vulnerabilities/additional-info/types";
import { DependencyType as DependencyTypeEnum } from "gql/graphql";

const dependencyTypeConfig: Record<DependencyTypeEnum, IDependencyTypeConfig> =
  {
    [DependencyTypeEnum.Transitive]: {
      color: "#175CD3",
      icon: "square-t",
      id: DependencyTypeEnum.Transitive.toLowerCase(),
    },
    [DependencyTypeEnum.Direct]: {
      color: "#B8075D",
      icon: "square-d",
      id: DependencyTypeEnum.Direct.toLowerCase(),
    },
    [DependencyTypeEnum.Undeterminable]: {
      color: "#D0D5DD",
      icon: "square-question",
      id: DependencyTypeEnum.Undeterminable.toLowerCase(),
    },
  } as const;

const DependencyType = ({
  dependencyType,
}: {
  dependencyType: DependencyTypeEnum | null | undefined;
}): React.JSX.Element => {
  const config =
    _.isNil(dependencyType) || !(dependencyType in dependencyTypeConfig)
      ? dependencyTypeConfig[DependencyTypeEnum.Undeterminable]
      : dependencyTypeConfig[dependencyType];

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.5}>
      <Icon
        icon={config.icon}
        iconColor={config.color}
        iconSize={"xl"}
        iconType={"fa-solid"}
      />
      <Text size={"md"} wordBreak={"break-word"} wordWrap={"normal"}>
        {_.capitalize(config.id)}
      </Text>
    </Container>
  );
};

const formatDependencyType = (
  dependencyType: DependencyTypeEnum | null | undefined,
): React.JSX.Element => {
  return <DependencyType dependencyType={dependencyType} />;
};

export { formatDependencyType, dependencyTypeConfig };
